import React from "react";
import { useParams } from "react-router";
import { Psalm } from "../../chants/Psalm";
import { TweakProvider } from "../../utils/TweakProvider";

export const PsalmPage: React.FC<{}> = () => {
    const { psalm } = useParams<{ psalm: string }>();

    return (
        <>
            <TweakProvider initialState={{}}>
                <div style={{ paddingTop: 32, paddingBottom: 32 }}>
                    <Psalm
                        psalmRef={{ type: "full", number: parseInt(psalm) }}
                    />
                </div>
            </TweakProvider>
        </>
    );
};
